"use client";

import { ContactInquiryForm } from "@/components/contact/ContactInquiryForm";

interface ContactSectionProps {
  title?: string;
  description?: string;
  emailLabel?: string;
}

const defaultProps = {
  title: "Ready to Build Something That Matters?",
  description:
    "Let's discuss your challenge and map out the smartest path forward.",
  emailLabel: "Or you can just email us",
};

export default function ContactSection({
  title = defaultProps.title,
  description = defaultProps.description,
  emailLabel = defaultProps.emailLabel,
}: ContactSectionProps) {
  return (
    <section className="py-12 lg:py-32 bg-card-texture bg-brand-yellow/10">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left side */}
          <div className="relative">
            {/* Background texture */}
            <div className="absolute inset-0 bg-card-texture bg-cover opacity-[0.03] rounded-xl" />

            {/* Content */}
            <div className="relative lg:p-8 rounded-xl">
              <h2 className="text-3xl md:text-4xl font-medium mb-6">{title}</h2>
              <div className="text-lg md:text-2xl">
                <p>{description}</p>
              </div>

              {/* Email section with better spacing */}
              <div className="mt-12">
                <p className="text-sm text-gray-light dark:text-gray-dark mb-2">
                  {emailLabel}
                </p>

                <div className="inline-flex items-center gap-2 group">
                  <div className="relative">
                    {/* Shape behind icon */}
                    <div className="absolute inset-0 bg-brand-yellow/40 rounded-lg transition-colors group-hover:bg-brand-yellow/90" />
                    <div className="relative p-2.5 rounded-lg">
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                        <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                      </svg>
                    </div>
                  </div>
                  <a
                    href="mailto:hello@township.agency"
                    className="text-lg hover:text-gray-light dark:hover:text-gray-dark transition-colors"
                  >
                    hello@township.agency
                  </a>
                </div>
              </div>
            </div>
          </div>

          <ContactInquiryForm surface="default" idPrefix="" />
        </div>
      </div>
    </section>
  );
}
